window.addEventListener('load', function () {
    const video = document.getElementById('bannerVideo');
    if (video) {
        video.muted = true;
        video.setAttribute('playsinline', 'true');
        video.play().then(() => {
            const parent = video.closest('.slideVideo');
            const clsvideo = document.querySelector('.custom-video-text.slideshow__slide-content');
        if (parent) {
            parent.setAttribute('loaded', '');
            const img = parent.querySelector('img');
        if (clsvideo) {
            clsvideo.style.opacity = '1';
            clsvideo.style.visibility = 'visible';
        }
        if (img) {
            img.style.opacity = '0';
            img.style.display = 'none';
        }
        }
        }).catch(error => {
            console.error('Error playing video:', error);
        });
    }
});

window.addEventListener('load', function () {
    const mediaWrappers = document.querySelectorAll('.image_optimization_load');
    if (!mediaWrappers.length) return;
    mediaWrappers.forEach(function (wrapper) {
        const dataSrc = wrapper.getAttribute('data-src');
        if (wrapper.tagName.toLowerCase() === 'img') {
            wrapper.src = dataSrc;
            return;
        }
        if (wrapper.tagName.toLowerCase() === 'video') {
            wrapper.poster = dataSrc;
            wrapper.muted = true;
            wrapper.setAttribute('playsinline', 'true');
            wrapper.preload = 'none';
            let played = false;
            const sources = wrapper.querySelectorAll('source');
            if (sources.length) {
                sources.forEach(source => source.src = dataSrc);
            } else {
                const newSource = document.createElement('source');
                newSource.src = dataSrc;
                wrapper.appendChild(newSource);
            }
            wrapper.load();
            const playVideo = () => {
                if (played) return;
                played = true;
                wrapper.play().catch(err => {
                    console.log('Autoplay blocked:', err);
                });
            };
            document.body.addEventListener('mousemove', playVideo, { once: true });
            document.body.addEventListener('mouseenter', playVideo, { once: true });
        }
    });
});
document.addEventListener("DOMContentLoaded", function () {
  const lcpImg = document.querySelector("img");
  if (lcpImg) {
    lcpImg.loading = "eager";
    lcpImg.fetchPriority = "high";
    lcpImg.decoding = "sync";
  }
  document.querySelectorAll("script[src]").forEach(script => {
    const src = script.src;
    if (!src.includes("shopify") && !src.includes("theme") && !script.defer && !script.async) {
      script.defer = true;
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
    const previewBar = document.querySelector('#PBarNextFrame');
    if (previewBar && !previewBar.hasAttribute('title')) {
     previewBar.setAttribute('title', 'Shopify preview bar');
    }
});




// function loadStockistk() {
//   if (window._stockistLoaded) return;
//   window._stockistLoaded = true;
//   const s = document.createElement('script');
//   s.src = 'https://a.klaviyo.com/media/js/onsite/onsite.js';
//   s.async = true;
//   document.body.appendChild(s);
// }

// document.addEventListener('DOMContentLoaded', () => {
//   const onFirstMove = () => {
//     loadStockistk();
//     document.body.removeEventListener('mousemove', onFirstMove);
//     document.body.removeEventListener('touchstart', onFirstInteraction);
//     document.body.removeEventListener('click', onFirstInteraction); 
//   };
//   document.body.addEventListener('mousemove', onFirstMove);
//   document.body.addEventListener('touchstart', onFirstInteraction);
//   document.body.addEventListener('click', onFirstInteraction);
// });